import { gql } from '@apollo/client';

const PHYSICIAN_FRAGMENT = gql`
  fragment PhysicianFragment on User {
    id
    firstName
    lastName
    contact {
      phone1
      nightPhone
      fax
      country
    }
    email
  }
`;

export default PHYSICIAN_FRAGMENT;
